export const dataIdentity = ({ data }) => data.data
